import { Button, Text } from "@aidron/aidron-ds";
import { CustomHeading } from "../../../../../components/StyledComponents/styleComponents.index";

export const OtbDraftRecoveryModal = ({ actions, ctx }) => {
  const { onContinue, onDiscardCategory, onDiscardAll } = actions || {};
  const { otbName, categories = [], currentCategory } = ctx || {};

  const currentIsPending = categories.includes(currentCategory);

  const overlayStyle = {
    position: "fixed",
    top: 0, left: 0, right: 0, bottom: 0,
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 9999,
    backdropFilter: "blur(2px)",
  };

  const modalStyle = {
    backgroundColor: "#fff",
    borderRadius: "12px",
    padding: "32px",
    boxShadow: "0 8px 32px rgba(0, 0, 0, 0.12)",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: "16px",
    maxWidth: "480px",
    textAlign: "center",
  };

  const categoryListStyle = {
    display: "flex",
    flexDirection: "column",
    gap: "4px",
    alignItems: "flex-start",
    textAlign: "left",
    backgroundColor: "#FDEDE3",
    borderRadius: "8px",
    padding: "12px 16px",
    inlineSize: "100%",
    boxSizing: "border-box",
  };

  return (
    <div style={overlayStyle} onClick={onContinue}>
      <div style={modalStyle} onClick={(e) => e.stopPropagation()}>
        <CustomHeading size="sm" margin="0 0 16px">
          Simulação em andamento
        </CustomHeading>

        <Text
          label={`Você tem uma simulação não salva para "${otbName}".`}
        />

        <div style={categoryListStyle}>
          <Text label="Categorias com alterações:" weight="bold" size="sm" />
          {categories.map((categoria) => (
            <Text key={categoria} label={`• ${categoria}`} size="sm" />
          ))}
        </div>

        <Text
          label='Para sair, cancele apenas a edição atual ou cancele toda a simulação. Em ambos os casos, os dados não serão salvos.'
          size="sm"
        />

        <div style={{ display: "flex", flexWrap: "wrap", justifyContent: "center", gap: "1rem" }}>
          <Button label="Continuar simulação" type="filled" onClick={onContinue} />

          {currentIsPending && (
            <Button
              label={`Cancelar edição de "${currentCategory}"`}
              type="outlined"
              onClick={onDiscardCategory}
            />
          )}

          <Button label="Cancelar toda a simulação" type="outlined" onClick={onDiscardAll} />
        </div>
      </div>
    </div>
  );
};